import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@api/client';
import { useNotificationStore } from '@store/notificationStore';

interface ChangePasswordRequest {
  current_password: string;
  new_password: string;
}

interface ChangePasswordResponse {
  message: string;
}

export const useChangePassword = () => {
  const { addNotification } = useNotificationStore();

  return useMutation({
    mutationFn: async (data: ChangePasswordRequest) => {
      const { data: response } = await apiClient.post<ChangePasswordResponse>(
        '/auth/change-password',
        data
      );
      return response;
    },
    onSuccess: (data) => {
      addNotification({
        message: data.message,
        type: 'success',
      });
    },
  });
};
